import { LOCATION_AREA } from '../../routes';
import customAxios from '../../customAxios';

async function deleteArea(_id: string) {
  try {
    return (await customAxios.delete(`${LOCATION_AREA}/${_id}`)).data;
  } catch (error: any) {
    console.error({LOCATION_AREA: error});
  }
}

export default deleteArea;
